
import { defineComponent } from "vue";
import { ColorPicker } from "vue-color-kit";

export default defineComponent({
	name: "imdex-color-picker",
	components: { ColorPicker },
	data() {
		return {
			tempColor:
				typeof this.color == "object"
					? this.color.color.toUpperCase()
					: this.color.toUpperCase(),
			tempName: "",
			tempRGB: null,
			debouncePvTimeout: null as number | null
		};
	},
	props: {
		index: {
			type: Number,
			default: 0
		},
		color: {
			type: [Object, String],
			default: () => ({ color: "#ff9900", name: "" })
		},
		forceColorUpdate: {
			type: Boolean,
			default: false
		}
	},
	beforeUnmount() {
		this.sendPvChange();
	},
	computed: {
		textInputHexColorUppercase: {
			get() {
				return this.tempColor.toUpperCase();
			},
			set(value: string) {
				if (value.length === 6 && value[0] != "#") {
					this.tempColor = "#" + value.replace(/[^0-9a-fA-F]/g, "0").toUpperCase();
					this.setColor();
					return;
				}

				if (value.length < 7) return; // hacky but makes the input feel better to use as it will fill all fields based on a single character input otherwise
				this.tempColor = value.toUpperCase();
				this.setColor();
			}
		}
	},
	methods: {
		setColor() {
			this.$nextTick(() => {
				// (color square on Display pane) we could debounce this to make it match the visualizer more closely; currently it is tied to the color picker instead.
				(this.$refs[`vue-color`] as any).selectColor(this.tempColor);
			});
		},
		changeColor(color: any) {
			this.tempRGB = color.rgba;
			this.tempColor = color.hex; // for picks / discrete colors, manually updating tempColor causes an update, but in other use cases causes a redraw of the palette
			this.sendDebouncedColorBy();
			//this.tempColor = color.hex;
			// this.$emit('change', {color:color.hex, name:this.tempName});
		},
		sendPvChange() {
			this.$emit("change", {
				color: this.textInputHexColorUppercase,
				name: this.tempName,
				rgba: this.tempRGB
			});
		},
		sendDebouncedColorBy() {
			if (this.debouncePvTimeout) {
				clearTimeout(this.debouncePvTimeout);
			}
			this.debouncePvTimeout = setTimeout(this.sendPvChange, 300);
		}
	},
	watch: {
		color: {
			deep: true,
			handler(v) {
				if (
					v.color &&
					this.tempColor &&
					v.color.toLowerCase() != this.tempColor.toLowerCase()
				) {
					this.tempColor = v.color;
				}
			}
		}
	}
});
